import {Container} from "../Core/Container";
import {Sprite} from "../Core/Sprite";
import {ColorUtil} from "../Core/Geom";
import {Callback} from "../Core/Reflection";
import {Ease} from "../Core/Animatable";
import {AudioChannel} from "../Core/AudioChannel";

export class Timer extends Container {

    public readonly base = this.addChild(new Sprite());
    public readonly circle = {width: 0};
    public readonly graphics = this.addChild(new PIXI.Graphics());
    public readonly stroke = this.addChild(new Sprite());

    private _progress = -1;
    private readonly colorEmpty;
    private readonly colorFull;
    private readonly fillAlpha;
    private readonly mode: "fill" | "erase";

    constructor(colorEmpty = 0xffffff, colorFull = 0x000000, fillAlpha = 1, mode: "fill" | "erase" = "fill") {
        super();
        this.colorEmpty = colorEmpty;
        this.colorFull = colorFull;
        this.fillAlpha = fillAlpha;
        this.mode = mode;
    }

    onLayout() {
        this.progress = 0;
    }

    get progress(): number {
        return this._progress;
    }

    set progress(value: number) {
        if (value < 0) value = 0;
        if (value > 1) value = 1;
        if (this._progress != value) {
            this._progress = value;
            const r = this.circle.width * 0.5;
            this.graphics.rotation = -Math.PI * 0.5;
            this.graphics.clear();
            this.graphics.beginFill(ColorUtil.interpolate(this.colorEmpty, this.colorFull, value), this.fillAlpha);
            if (this.mode === "erase") {
                if (value === 0) {
                    this.graphics.drawCircle(0, 0, r);
                } else if (value < 1) {
                    const a = 2 * Math.PI * this._progress;
                    this.graphics.arc(0, 0, r, a, 2 * Math.PI);
                    this.graphics.lineTo(0, 0);
                }
            } else {
                if (value === 1) {
                    this.graphics.drawCircle(0, 0, r);
                } else if (value > 0) {
                    const a = 2 * Math.PI * this._progress;
                    this.graphics.arc(0, 0, r, 0, a);
                    this.graphics.lineTo(0, 0);
                }
            }
            this.graphics.endFill();
        }
    }

    show(duration?: number | Callback, cb?: Callback) {
        if (typeof duration === "function") {
            cb = duration;
            duration = undefined;
        }
        this.visible = true;
        this.progress = 0;
        this.alphaFrom(0, 0.2, () => {
            if (duration) {
                AudioChannel.SFX.play("timer-ticks");
                this.tweenTo<Timer>(duration as number, Ease.none, {
                    progress: 1,
                    onComplete: () => {
                        AudioChannel.SFX.play("timer-ding");
                        if (cb) cb();
                    }
                });
            } else if (cb) {
                cb();
            }
        });
    }


    hide(cb?: Callback) {
        this.alphaTo(0, 0.2, () => {
            this.alpha = 1;
            this.visible = false;
            if (cb) cb();
        });
    }
}